import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { AuthProvider } from './hooks/AuthContext';

import Login from './modules/login/Login'
import ValidateSession from './modules/login/ValidateSession'
import Layout from './modules/layout/Layout'
import Dash from './modules/dashboard/dash'
import DashboardStats from './modules/dashboard/DashboardStats'
import Users from './modules/users/user'
import Roles from './modules/role/role'
import Solutions from './modules/solution/solutions'
import Clients from './modules/clients/Clients'
import Deliverables from './modules/deliverables/Deliverables'
import ProjectDetail from './modules/projects/ProjectDetail'
import Projects from './modules/projects/Projects'
import Permissions from './modules/permission/permission'
import Solution from './modules/solution/solution'
import Area from './modules/area/area'
import Resources from './modules/resources/Resources'
import PermissionWrapper from './hooks/PermissionWrapper';

import NotFoundPage from './modules/layout/404';
import RequireAuth from './hooks/RequireAuth';

Sentry.init({
  dsn: "https://b08257525ac801efc7e3e50edfb367ac@o1076259.ingest.us.sentry.io/4508934229721088"
});

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <StrictMode>
      <Router>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="validate" element={<ValidateSession />} />
            <Route path="/app" element={<RequireAuth><Layout /></RequireAuth>}>
              <Route index element={<Dash />} />
              <Route path="soluciones" element={<Solutions />} />
              <Route path="solucion/:solutionId/view" element={<Solution />} />
              <Route path="usuarios" element={
                <PermissionWrapper requiredPermissions={['menu_user']}> 
                  <Users />
                </PermissionWrapper>
              } />
              <Route path="roles" element={<Roles />} />
              <Route path="permisos" element={<Permissions />} />
              <Route path="areas" element={<Area />} />
              <Route path="recursos" element={
                <PermissionWrapper requiredPermissions={['menu_resource']}> 
                  <Resources />
                </PermissionWrapper>
                } />
              <Route path="dashboard" element={
                <PermissionWrapper requiredPermissions={['menu_report']}>
                  <DashboardStats />
                </PermissionWrapper>
              } />
              <Route path="clientes" element={<Clients />} />
              <Route path="entregables" element={<Deliverables />} />
              <Route path="proyecto/:projectId" element={<ProjectDetail />} />
              <Route path="proyectos" element={<Projects />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
      </Router>
    </StrictMode>
  </AuthProvider>
)
